import styled, { css } from 'styled-components';

import { Image } from 'components/image';
import { Stepper } from 'components/stepper';
import { ErrorAlert } from 'components/error-alert';
import { TextColor, BadgeColor, ErrorColor } from 'types';
import {
  body,
  heading2,
  heading3,
  captionBold,
  bodySemibold,
} from 'styles/mixins/fonts';

export const StyledStepper = styled(Stepper)`
  flex: unset;
`;

export const FormContainer = styled.div`
  flex: 1;
  display: flex;
  overflow-y: auto;
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  overflow-x: hidden;
  flex-direction: column;
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  ${({ theme }) =>
    !theme.responsive.isMobile &&
    css`
      > button {
        min-width: 136px;
      }
    `}
`;

export const ShipHint = styled(ErrorAlert)`
  svg {
    width: 40px;
    height: 40px;
  }
`;

export const ShipHintTitle = styled.p`
  ${heading2};
`;

export const ShipHintText = styled.p`
  ${heading3};
  font-weight: 400;
`;

export const SummaryText = styled.p`
  ${body};
  width: 100%;
  margin-bottom: 16px;
  color: ${({ theme }) => theme.config.text[TextColor.Secondary]};
`;

export const SummarySection = styled.div<{ $shipping?: boolean }>`
  gap: 12px;
  width: 100%;
  display: flex;
  padding: 16px;
  border-radius: 16px;
  flex-direction: column;
  ${({ theme, $shipping }) => css`
    background-color: ${$shipping
      ? theme.config.errorColor[ErrorColor.LightBlue].background
      : theme.config.badge[BadgeColor.TetrieryBlue].default.bg};
  `}

  & + & {
    margin-top: 12px;
  }
`;

export const SummaryHeading = styled.p<{ $shipping?: boolean }>`
  ${captionBold};
  gap: 8px;
  display: flex;
  align-items: center;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${({ theme, $shipping }) =>
    theme.config.text[$shipping ? TextColor.Blue : TextColor.Secondary]};

  svg {
    width: 20px;
    height: 20px;
    path {
      fill: currentColor;
    }
  }
`;

export const SummaryLine = styled.div`
  gap: 12px;
  display: flex;
  align-items: center;
`;

export const SummaryImage = styled(Image)`
  flex-shrink: 0;
  border-radius: 8px;
`;

export const SummaryName = styled.p`
  ${bodySemibold};
  flex: 1;
  min-width: 0;
`;

export const SummaryQuantity = styled.p`
  ${heading3};
  flex-shrink: 0;
`;

export const SummaryButtons = styled.div`
  gap: 16px;
  width: 100%;
  display: flex;
  margin-top: 24px;
`;
